export default __webpack_public_path__ + "static/media/DE.fa697234.svg";